module.exports = __webpack_public_path__ + "img/search-via-cv-mobile.818ff81.svg";